import { render, staticRenderFns } from "./MediaForm.vue?vue&type=template&id=3be8b531&scoped=true&"
import script from "./MediaForm.vue?vue&type=script&lang=js&"
export * from "./MediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8b531",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be8b531')) {
      api.createRecord('3be8b531', component.options)
    } else {
      api.reload('3be8b531', component.options)
    }
    module.hot.accept("./MediaForm.vue?vue&type=template&id=3be8b531&scoped=true&", function () {
      api.rerender('3be8b531', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/landing-page/components/MediaForm.vue"
export default component.exports